module.exports = __webpack_public_path__ + "img/NFT-Globe1.8c8e0c49.png";